<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title class="text-h5 pa-4"> Add Administrator </v-card-title>

      <v-divider></v-divider>

        <v-card-text class="pa-6">
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="formData.email"
            :rules="emailRules"
            label="Email ID"
            type="email"
            variant="outlined"
            density="compact"
            required
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey" variant="text" @click="handleClose"> Cancel </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :disabled="loading"
          :loading="loading"
          @click="handleSubmit"
        >
          Add Admin
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Snackbar -->
  
  </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { create_user } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
export default {
  name: "CreateAdminDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
      formData: {
        email: "",
      },
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        email: "",
      };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;
      const input = {
        user_email_id: this.formData.email,
      };
      try {
        const response = await client.graphql({
          query: create_user,
          variables: {
            input: input,
          },
        });
        // console.log(response);
        const responseData = JSON.parse(response.data.create_user);
        if (responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message: responseData.status_message,
            color: "success",
          };
          this.$emit("created", 0);
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message: responseData.status_message,
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error creating admin:", error);
        this.snackbar = {
          show: true,
          message: error.message,
          color: "error",
        };
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>

